import { useInfiniteQuery } from '@tanstack/react-query'
import { getSearchAgents } from "../api/get-search-agents"

export const useGetSearchAgents = ({ params, options = {} }) => {
  return useInfiniteQuery({
    queryKey: ['get-search-agents', params],
    queryFn: ({ pageParam = 1 }) => getSearchAgents({ ...params, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      return !!lastPage?.data?.data?.length ? allPages.length + 1 : undefined;
    },
    ...options
  })
}
